import styled, { css } from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;

  @media ${sizes.desktop} {
    border-radius: 16px;
  }

  ${({ $color }) =>
    $color &&
    css`
      background-color: ${th(`colors.${$color}`)};
    `}
`;

export const MemberImage = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MediumText = styled.div`
  font-weight: 500;
`;

export const Birthday = styled.span`
  display: none;

  @media ${sizes.largeDesktop} {
    display: inline;
  }
`;
